import {InputLabel} from '@material-ui/core';
import {EditorWrapper} from './style'
import 'react-quill/dist/quill.snow.css';

const Editor = props => {
    const {label, value, onChange, placeholder} = props;

    return (
        <div style={{margin: '10px 0'}}>
            {label &&
            <InputLabel className='mb-0 text-primary font-13'>
                {label}
            </InputLabel>
            }
            <EditorWrapper theme='snow' value={value} placeholder={placeholder} onChange={onChange} modules={{
                toolbar: [
                    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                    [{'header': '1'}, {'header': '2'}],
                    [{size: []}],
                    [{'color': []}, {'background': []}],
                    [{'list': 'ordered'}, {'list': 'bullet'},
                        {'indent': '-1'}, {'indent': '+1'}],
                    [{'direction': 'rtl'}],
                    ['link']
                        //['link', 'image', 'video'],
                        ['clean']
                ]
            }
            }/>
        </div>
    );
};

export default Editor;
